import { fetchDataFromBackend } from "../api/api";
import logger from "../core/utils/logger";

const isSimulation = import.meta.env.VITE_BACKEND_DATA_SIMULATION === "true";

export const OrganizationSettingsService = {
    /**
     * Get organization-wide settings (admin only)
     */
    async getOrganizationSettings() {
        try {
            if (isSimulation) {
                logger.log("Simulation mode enabled. Returning default organization settings.");
                return {
                    id: 1,
                    organizationId: "org1",
                    customWorkerOrder: null
                };
            }

            const response = await fetchDataFromBackend("/OrganizationSettings/GetSettings", {
                skipAuth: false,
                method: 'get'
            });

            logger.log("Organization settings response:", response);
            return response;
        } catch (error) {
            if (error.response?.status === 404) {
                // No settings exist yet, return defaults
                logger.log("No organization settings found, returning defaults");
                return {
                    customWorkerOrder: null
                };
            }
            logger.error("❌ Error fetching organization settings:", error);
            throw error;
        }
    },

    /**
     * Save or update organization-wide settings (admin only)
     */
    async saveOrganizationSettings(settings) {
        try {
            if (isSimulation) {
                logger.log("Simulation mode enabled. Simulated saving organization settings:", settings);
                return settings;
            }

            const response = await fetchDataFromBackend("/OrganizationSettings/SaveSettings", {
                skipAuth: false,
                method: 'put',
                data: settings
            });

            logger.log("Save organization settings response:", response);
            return response;
        } catch (error) {
            logger.error("❌ Error saving organization settings:", error);
            throw error;
        }
    }
};
